/*
 * @Author: your name
 * @Date: 2021-01-14 10:46:21
 * @LastEditTime: 2021-04-23 11:42:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dy\src\pages\Home\components\TimeTab\index.tsx
 */
import React, { useEffect } from 'react';
import { Tab } from '@alifd/next';


const TimeTab = ({ list, onChange, activeKey }) => {
  useEffect(() => {
  }, []);

  return (
    <section style={{ width: '100%' }}>
      <Tab activeKey={activeKey} shape="capsule" onChange={(tabKey) => onChange(tabKey)}>
        {
          list.map((pane) => (<Tab.Item
            title={pane.tab}
            key={pane.key}
            style={{
              width: '90px',
              height: '30px',
              textAlign: 'center',
              lineHeight: '5px',
            }}
            className="justify-tabs-tab"
          />))
        }
      </Tab>
    </section>
  );
};
export default TimeTab;
